/**
 * Common Translations - Portuguese (PT-BR)
 */
export const commonPt = {
  // Actions
  'common.actions.next': 'Próximo',
  'common.actions.back': 'Voltar',
  'common.actions.cancel': 'Cancelar',
  'common.actions.close': 'Fechar',
  'common.actions.edit': 'Editar',
  'common.actions.submit': 'Enviar',
  'common.actions.tryAgain': 'Tentar Novamente',
  'common.actions.retry': 'Tentar Novamente',

  // States
  'common.states.loading': 'Carregando...',
  'common.states.submitting': 'Enviando...',

  // Labels
  'common.labels.required': '*',
  'common.labels.optional': '(Opcional)',
  'common.labels.step': 'Passo {{current}} de {{total}}',
}
